import styled from 'styled-components'
import { COLORS } from 'utils'

interface IText {
  margintop?: string
  marginright?: string
  marginbottom?: string
  marginleft?: string
  fontcolor?: string
  fontsize?: '16px' | '13px'
}

export const Text = styled.span<IText>`
  margin-top: ${({ margintop }) => margintop || 0};
  margin-right: ${({ marginright }) => marginright || 0};
  margin-bottom: ${({ marginbottom }) => marginbottom || 0};
  margin-left: ${({ marginleft }) => marginleft || 0};
  color: ${({ fontcolor }) => fontcolor || COLORS.black};
  font-size: ${({ fontsize }) => fontsize || '16px'};
  font-weight: 400;
  font-family: Arial, Helvetica, sans-serif;
`
